import React, { useState, useEffect, useContext, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import AppContext from '../../../../context/AppContext';
import "../../../../assets/css/screens/serviceprovider/dashboard/helpandsupport/WorkerChat.css";
import WorkerNavbar from '../../../../components/serviceprovider/workerdashboard/Workernavbar/WorkerNavbar';
import echo from '../../../../config/echo';
// ── Import Broken-down Components ──
import ChatHeader from '../../../../components/serviceprovider/workerdashboard/workerchat/ChatHeader';
import ChatMessagesList from '../../../../subscreens/serviceprovider/dashboard/workerdashboard/workerchat/ChatMessagesList';
import ChatInput from '../../../../components/serviceprovider/workerdashboard/workerchat/ChatInput';
import MediaPreviewModal from '../../../../components/serviceprovider/workerdashboard/workerchat/MediaPreviewModal';

const WorkerChat = () => {
  const { baseUrl, authToken,baseUrlForFile } = useContext(AppContext);
  const { conversationId }     = useParams();
  const location               = useLocation();
  const navigate               = useNavigate();

  const ticketDescription = location.state?.description;

  const [messages, setMessages] = useState([]);
  const [type,     setType]     = useState('');
  const [sending, setSending] = useState(false);

  const [customerMedia, setCustomerMedia] = useState([]);
const [workerProofs, setWorkerProofs] = useState([]);
const [isResolved, setIsResolved] = useState();
const [previewImage, setPreviewImage] = useState(null);
const [previewVideo, setPreviewVideo] = useState(null);

  const bottomRef = useRef(null);

const sendMessage = async () => {
  if (sending) return; // Agar already send ho raha hai to dobara mat bhejo

  if (isResolved) {
    alert("This ticket has been resolved.");
    return;
  }

  if (!type.trim() || !conversationId) return;

  setSending(true);

  const formData = new FormData();
  formData.append("whconversation_id", Number(conversationId));
  formData.append("message", type.trim());
  formData.append("sender", "worker");
  formData.append("type", "text");

  try {
    const response = await axios.post(
      `${baseUrl}/worker/createchat`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    console.log(response.data);

    setType("");
  } catch (err) {
    console.log(err.response?.data || err.message);
  } finally {
    setSending(false);
  }
};
 const handleKey = (e) => {
  if (e.key === "Enter" && !sending) {
    sendMessage();
  }
};

  
  // =========================
  // VIEW CHATS
  // =========================
const fetchChats = () => {
  const auth = authToken || localStorage.getItem('authToken');

  axios.get(`${baseUrl}/worker/receviechat`, {
    headers: { Authorization: `Bearer ${auth}` },
    params: { whconversation_id: conversationId },
  })
 .then(res => {
  const chats = res.data.messages || [];


  setMessages(chats);

  
  setCustomerMedia(res.data.customerMedia || []);
  setWorkerProofs(res.data.workerProofs || []);

      setIsResolved(res.data.status === "resolved");
})
  .catch(console.log);
};

  // Scroll to bottom on new message
useEffect(() => {
  console.log("Conversation ID:", conversationId);

  if (conversationId) {
    fetchChats();
  }
}, [conversationId]);
useEffect(() => {

  console.log("WORKER CHAT MOUNTED");

  if (!conversationId) return;

  console.log("Joining Conversation:", `conversation-${conversationId}`);

  const channel = echo.channel(`conversation-${conversationId}`);
channel.listen(".ChatMessageSent", (event) => {

  // ✅ Admin ne ticket resolve kar di
  if (event.status === "resolved") {
    setIsResolved(true);
  }

  // ✅ Agar message hi nahi hai to yahin stop
  if (!event.chat) return;

  setMessages(prev => {
    const exists = prev.find(msg => msg.id === event.chat.id);

    if (exists) {
      return prev;
    }

    return [...prev, event.chat];
  });

});

  return () => {
    console.log("LEAVING CHANNEL");
    echo.leave(`conversation-${conversationId}`);
  };

}, [conversationId]);
 return (
  <>
    <div className="wc-navbar-wrapper">
      {/* <WorkerNavbar /> */}
    </div>

    <div className="wc-root">

      <ChatHeader />

      <ChatMessagesList
        ticketDescription={ticketDescription}
        customerMedia={customerMedia}
        workerProofs={workerProofs}
        baseUrlForFile={baseUrlForFile}
        setPreviewImage={setPreviewImage}
        setPreviewVideo={setPreviewVideo}
        messages={messages}
        bottomRef={bottomRef}
      />

    
{!isResolved ? (
  <ChatInput
    type={type}
    setType={setType}
    handleKey={handleKey}
    sendMessage={sendMessage}
    sending={sending}
  />
) : (
  <div className="wc-ticket-resolved">
  <span className="wc-ticket-resolved__badge">
    ✅ This ticket has been resolved. Chat is closed.
  </span>
</div>
)}
      <MediaPreviewModal
        previewImage={previewImage}
        setPreviewImage={setPreviewImage}
        previewVideo={previewVideo}
        setPreviewVideo={setPreviewVideo}
      />

    </div>
  </>
);
}
export default WorkerChat;